"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VirtualizedSeparatorStyled = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _menu = require("../../../menu");
const shouldForwardProp = propName => {
  switch (propName) {
    case "optionHeight":
    case "shouldVirtualize":
    case "top":
      // Just add any extra props here :)
      return false;
  }
  return true;
};
const VirtualizedSeparatorStyled = (0, _styled.default)(_menu.MenuSeparator, {
  shouldForwardProp
})`
    ${_ref => {
  let {
    shouldVirtualize,
    optionHeight,
    top
  } = _ref;
  return shouldVirtualize ? `
                ${top ? `top: ${+top - optionHeight}px` : ``};
                transform: translate(0, ${optionHeight}px);
                position: absolute;
                width: calc(100% - 32px);
              ` : ``;
}}
`;
exports.VirtualizedSeparatorStyled = VirtualizedSeparatorStyled;
//# sourceMappingURL=VirtualizedSeparatorStyled.js.map